/** The three views for aligning two pointclouds */
export enum Perspective {
  topView = "topView",
  frontView = "frontView",
  sideView = "sideView",
}
